import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component";
import { UPDATE_PARTY_IN_MANDATE } from "../../Schema/Mandate";

export default function PartyNumberingForm({
  open,
  editData,
  setRefetch,
  handleClose,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [updatePartyInMandate] = useMutation(UPDATE_PARTY_IN_MANDATE, {
    onCompleted: ({ updatePartyInMandate }) => {
      setLoading(false);
      if (updatePartyInMandate?.isSuccess === true) {
        // setAlert(true, "success", updatePartyInMandate?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updatePartyInMandate?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    numbering: Yup.number().nullable().required(t("required")),
  });

  const formik = useFormik({
    initialValues: {
      numbering: null,
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      updatePartyInMandate({
        variables: {
          id: editData?._id,
          ...values,
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;


  useEffect(() => {
    if (editData) {
      setFieldValue("numbering", editData?.numbering || null);
    }
  }, [editData, open]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs" fullWidth>
      <DialogTitleComp
        title={t("modal_title_update_numbering")}
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_numbering")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  className="text-field"
                  placeholder={t("thead_numbering")}
                  {...getFieldProps("numbering")}
                  error={Boolean(touched.numbering && errors.numbering)}
                  helperText={touched.numbering && errors.numbering}
                />
              </Grid>



              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
